import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import Slider from "react-slick";
import { IoIosArrowDropleftCircle, IoIosArrowDroprightCircle } from "react-icons/io";

import TestimonialCard from './TestimonialCard';

import './Testimonials.css'

const TESTIMONIALS_URL = "/testimonials"

function Testimonials() {

    const [testimonials, setTestimonials] = useState('')
    const sliderRef = useRef();

    useEffect(() => {
        async function getTestimonials() {
          try {
            const response = await axios.get(process.env.REACT_APP_DEPT_API + TESTIMONIALS_URL);
            setTestimonials(response.data);
          } catch (error) {
            console.error(error);
          }
        }
        getTestimonials()
      }, [])


    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: true,
        fade: false,
        pauseOnHover: false,
        adaptiveHeight: true
    };

    const gotoNext = () => {
        sliderRef.current.slickNext();
    }

    const gotoPrev = () => {
        sliderRef.current.slickPrev();
    }

    return (
        <div className='testimonials'>
            <div className='section__container'>
                <div className='section'>
                    <h1 className='section__header'>Testimonials</h1>
                    <IoIosArrowDropleftCircle onClick={gotoPrev} className='testimonial__prev'/>
                    <div className='testimonials__slider'>
                        <Slider {...settings} ref={sliderRef}>
                            {testimonials && testimonials.map((test) => (
                                <TestimonialCard 
                                    id={test._id}
                                    key={test._id}
                                    name={test.name}
                                    text={test.testimonial}
                                    batch={test.batch}
                                    image={test.image.url}
                                    designation={test.designation}
                                />
                            ))}
                        </Slider>
                    </div>
                    <IoIosArrowDroprightCircle onClick={gotoNext} className='testimonial__next'/>
                </div>
            </div>
        </div>
    )
}

export default Testimonials